import { render } from "./ResultPanel.vue?vue&type=template&id=06b6b0e2"
import script from "./ResultPanel.vue?vue&type=script&lang=js"
export * from "./ResultPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__